export function loginFilterValuesForEmbed(user: any, isInternal: boolean): string[] {
  if (isInternal) {
    return ["TEREOS"];
  }
  const s = user || {};
  const rawFields = [
    s.username,
    s.email,
    s.customer_name,
    s.customerName,
    s.displayName,
    s.sideBarName,
    s.loginNormalized,
    s.login_normalized,
    s.access_code,
    s.accessCode,
  ];
  const out = new Set<string>();
  for (const f of rawFields) {
    if (f == null || f === "") continue;
    const str = String(f).trim();
    if (!str) continue;
    for (const v of caseVariants(str)) {
      out.add(v);
    }
    if (str.includes("@")) {
      out.add(str.toLowerCase());
    }
  }
  return Array.from(out);
}

function caseVariants(s: string): string[] {
  const raw = (s || "").trim();
  if (!raw) return [];
  return Array.from(
    new Set([
      raw,
      raw.toUpperCase(),
      raw.toLowerCase(),
      raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase(),
    ])
  );
}
